import React from 'react';
import { ArrowRight } from 'lucide-react';
import './Process.css';

const Process = () => {
  const steps = [
    {
      number: '01',
      title: 'Anfrage senden',
      description: 'Füllen Sie unser Formular aus und teilen Sie uns Ihre Wünsche mit'
    },
    {
      number: '02',
      title: 'Rückmeldung erhalten',
      description: 'Wir melden uns innerhalb von 24 Stunden bei Ihnen zurück'
    },
    {
      number: '03',
      title: 'Besichtigung & Angebot',
      description: 'Lernen Sie unsere Location kennen und erhalten Sie Ihr persönliches Angebot'
    }
  ];

  return (
    <section className="process section-padding" id="prozess">
      <div className="container">
        <div className="process-header">
          <h2 className="heading-1 text-center">
            So einfach planen Sie Ihr Event
          </h2>
          <p className="body-large text-center space-top-md">
            In nur 3 Schritten zu Ihrer Traumveranstaltung
          </p>
        </div>

        <div className="process-steps space-top-xxl">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="step-number">{step.number}</div>
              <h3 className="heading-3 space-top-md">{step.title}</h3>
              <p className="body-regular space-top-sm">{step.description}</p>
              {index < steps.length - 1 && (
                <div className="step-arrow">
                  <ArrowRight size={24} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;